/**
 * Frame Bed / Divan Bed Cart Handler
 * Adds main product + mattress addon + headboard height addon + gas lift storage addon + storage drawers addon as separate line items
 */
(function () {
    'use strict';

    if (!document.getElementById('mattress-products-data')) return;

    var form = document.getElementById('headboard-product-form');
    if (!form) return;

    // Headboard height addon handles
    var HEIGHT_ADDON_HANDLES = {
        '60': 'headboard-height-60',
        '70': 'headboard-height-70',
        '54': null
    };

    // Gas Lift Storage addon - read handle from hidden input (set by Liquid per template)
    var gasLiftHandleEl = document.getElementById('gas-lift-product-handle');
    var GAS_LIFT_HANDLE = gasLiftHandleEl ? gasLiftHandleEl.value : 'gas-lift-storage';

    // Gas lift variant mapping (option value -> variant option to match)
    var GAS_LIFT_VARIANTS = {
        'End Lift': 'End Lift',
        'Left Lift': 'Left Lift',
        'Right Lift': 'Right Lift'
    };

    // Storage Drawers addon
    var DRAWERS_HANDLE = 'storage-drawers';

    // Set up gas lift radio listeners
    // Fallback price: £200 for tv-gas-lift-storage, £100 for others
    var GAS_LIFT_FALLBACK_PRICE = (GAS_LIFT_HANDLE === 'tv-gas-lift-storage') ? 20000 : 10000;

    setTimeout(function () {
        var gasLiftRadios = document.querySelectorAll('input[name="gas-lift-select"]');
        gasLiftRadios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                var label = document.getElementById('selected-gas-lift');
                var prop = document.getElementById('gas-lift-property');
                if (radio.value === 'none') {
                    if (label) label.textContent = 'None';
                    if (prop) prop.value = '';
                    document.getElementById('gas-lift-addon-id').value = '';
                    document.getElementById('gas-lift-addon-price').value = '0';
                    // Notify price display
                    document.dispatchEvent(new CustomEvent('gas-lift-addon-updated', {
                        detail: { price: 0, variantId: null, title: 'None' }
                    }));
                } else {
                    if (label) label.textContent = radio.value;
                    if (prop) prop.value = radio.value;

                    // Immediately set fallback price so display updates right away
                    document.getElementById('gas-lift-addon-price').value = GAS_LIFT_FALLBACK_PRICE;
                    document.dispatchEvent(new CustomEvent('gas-lift-addon-updated', {
                        detail: { price: GAS_LIFT_FALLBACK_PRICE, variantId: null, title: radio.value }
                    }));

                    // Fetch the gas lift product to get actual variant id and price
                    fetch('/products/' + GAS_LIFT_HANDLE + '.js')
                        .then(function (res) { return res.ok ? res.json() : null; })
                        .then(function (product) {
                            if (product) {
                                var matchVariant = product.variants.find(function (v) {
                                    return v.title === radio.value ||
                                        v.option1 === radio.value ||
                                        v.option2 === radio.value ||
                                        v.option3 === radio.value;
                                });
                                if (matchVariant) {
                                    document.getElementById('gas-lift-addon-id').value = matchVariant.id;
                                    document.getElementById('gas-lift-addon-price').value = matchVariant.price;
                                    // Update price display with actual price
                                    document.dispatchEvent(new CustomEvent('gas-lift-addon-updated', {
                                        detail: { price: matchVariant.price, variantId: matchVariant.id, title: radio.value }
                                    }));
                                }
                            }
                        });
                }
            });
        });
    }, 50);

    // Set up drawers radio listeners
    setTimeout(function () {
        var drawersRadios = document.querySelectorAll('input[name="drawers-select"]');
        drawersRadios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                var label = document.getElementById('selected-drawers');
                var prop = document.getElementById('drawers-property');
                if (radio.value === 'none') {
                    if (label) label.textContent = 'None';
                    if (prop) prop.value = '';
                    document.getElementById('drawers-addon-id').value = '';
                    document.getElementById('drawers-addon-price').value = '0';
                    // Notify price display
                    document.dispatchEvent(new CustomEvent('drawers-addon-updated', {
                        detail: { price: 0, variantId: null, title: 'None' }
                    }));
                } else {
                    if (label) label.textContent = radio.value;
                    if (prop) prop.value = radio.value;

                    // Fetch the drawers product to get variant id and price
                    fetch('/products/' + DRAWERS_HANDLE + '.js')
                        .then(function (res) { return res.ok ? res.json() : null; })
                        .then(function (product) {
                            if (product) {
                                var matchVariant = product.variants.find(function (v) {
                                    return v.title === radio.value ||
                                        v.option1 === radio.value ||
                                        v.option2 === radio.value ||
                                        v.option3 === radio.value;
                                });
                                if (matchVariant) {
                                    document.getElementById('drawers-addon-id').value = matchVariant.id;
                                    document.getElementById('drawers-addon-price').value = matchVariant.price;
                                    // Update price display with actual price
                                    document.dispatchEvent(new CustomEvent('drawers-addon-updated', {
                                        detail: { price: matchVariant.price, variantId: matchVariant.id, title: radio.value }
                                    }));
                                }
                            }
                        });
                }
            });
        });
    }, 50);

    setTimeout(function () {
        var btn = document.getElementById('framebed-add-to-cart-btn');
        if (btn) btn.addEventListener('click', handleAddToCart, true);

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            handleAddToCart(e);
        }, true);
    }, 100);

    function handleAddToCart(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var btn = document.getElementById('framebed-add-to-cart-btn');
        var originalText = btn ? btn.innerHTML : '';
        if (btn) { btn.innerHTML = '<span>Adding...</span>'; btn.disabled = true; }

        var formData = new FormData(form);
        var variantId = formData.get('id');
        var quantity = parseInt(formData.get('quantity')) || 1;

        // Collect form properties (skip empty and internal values)
        var properties = {};
        for (var pair of formData.entries()) {
            if (pair[0].startsWith('properties[')) {
                var name = pair[0].replace('properties[', '').replace(']', '');
                if (name !== '_price_addon' && pair[1] && pair[1].trim() !== '') {
                    properties[name] = pair[1];
                }
            }
        }

        // Get headboard size
        var sizeInput = document.querySelector('input[name="properties[Headboard Size]"]:checked');
        var sizeValue = sizeInput ? sizeInput.value : '54"';
        var sizeMatch = sizeValue.match(/\d+/);
        var sizeNumber = sizeMatch ? sizeMatch[0] : '54';

        // Check for mattress addon
        var mattressEl = document.getElementById('mattress-addon-id');
        var hasMattress = mattressEl && mattressEl.value && mattressEl.value !== '' && mattressEl.value !== '0';

        // Check for headboard height addon
        var heightAddonHandle = HEIGHT_ADDON_HANDLES[sizeNumber];

        // Check for gas lift storage addon
        var gasLiftPropEl = document.getElementById('gas-lift-property');
        var gasLiftIdEl = document.getElementById('gas-lift-addon-id');
        var hasGasLift = gasLiftPropEl && gasLiftPropEl.value && gasLiftPropEl.value.trim() !== '';

        // Check for storage drawers addon
        var drawersPropEl = document.getElementById('drawers-property');
        var drawersIdEl = document.getElementById('drawers-addon-id');
        var hasDrawers = drawersPropEl && drawersPropEl.value && drawersPropEl.value.trim() !== '';

        // If gas lift selected but variant ID not yet fetched, fetch it now
        var gasLiftReady = Promise.resolve();
        if (hasGasLift && (!gasLiftIdEl.value || gasLiftIdEl.value === '' || gasLiftIdEl.value === '0')) {
            gasLiftReady = fetch('/products/' + GAS_LIFT_HANDLE + '.js')
                .then(function (res) { return res.ok ? res.json() : null; })
                .then(function (product) {
                    if (product) {
                        var matchVariant = product.variants.find(function (v) {
                            return v.title === gasLiftPropEl.value ||
                                v.option1 === gasLiftPropEl.value ||
                                v.option2 === gasLiftPropEl.value ||
                                v.option3 === gasLiftPropEl.value;
                        });
                        if (matchVariant) {
                            gasLiftIdEl.value = matchVariant.id;
                            document.getElementById('gas-lift-addon-price').value = matchVariant.price;
                        }
                    }
                });
        }

        // If drawers selected but variant ID not yet fetched, fetch it now
        var drawersReady = Promise.resolve();
        if (hasDrawers && (!drawersIdEl.value || drawersIdEl.value === '' || drawersIdEl.value === '0')) {
            drawersReady = fetch('/products/' + DRAWERS_HANDLE + '.js')
                .then(function (res) { return res.ok ? res.json() : null; })
                .then(function (product) {
                    if (product) {
                        var matchVariant = product.variants.find(function (v) {
                            return v.title === drawersPropEl.value ||
                                v.option1 === drawersPropEl.value ||
                                v.option2 === drawersPropEl.value ||
                                v.option3 === drawersPropEl.value;
                        });
                        if (matchVariant) {
                            drawersIdEl.value = matchVariant.id;
                            document.getElementById('drawers-addon-price').value = matchVariant.price;
                        }
                    }
                });
        }

        // Build everything, then submit
        Promise.all([gasLiftReady, drawersReady]).then(function () {
            buildAndSubmit(variantId, quantity, properties, hasMattress, mattressEl, heightAddonHandle, sizeNumber, hasGasLift, gasLiftIdEl, hasDrawers, drawersIdEl, btn, originalText);
        });
    }

    function buildAndSubmit(variantId, quantity, properties, hasMattress, mattressEl, heightAddonHandle, sizeNumber, hasGasLift, gasLiftEl, hasDrawers, drawersEl, btn, originalText) {
        var items = [];
        var promises = [];

        // If mattress addon selected, add info to properties
        if (hasMattress) {
            var mattressTitle = document.getElementById('mattress-addon-title').value || 'Mattress';
            var mattressPrice = parseInt(document.getElementById('mattress-addon-price').value || '0');
            var formatted = '\u00a3' + (mattressPrice / 100).toFixed(2);
            properties['Mattress'] = mattressTitle + ' (+' + formatted + ')';
        }

        // If gas lift addon selected, add info to properties
        if (hasGasLift) {
            var gasLiftProp = document.getElementById('gas-lift-property');
            var gasLiftPrice = parseInt(document.getElementById('gas-lift-addon-price').value || '0');
            var gasFormatted = '\u00a3' + (gasLiftPrice / 100).toFixed(2);
            var gasLiftValue = gasLiftProp ? gasLiftProp.value : '';
            properties['Gas Lift Storage'] = gasLiftValue + ' (+' + gasFormatted + ')';
        }

        // If drawers addon selected, add info to properties
        if (hasDrawers) {
            var drawersProp = document.getElementById('drawers-property');
            var drawersPrice = parseInt(document.getElementById('drawers-addon-price').value || '0');
            var drawersFormatted = '\u00a3' + (drawersPrice / 100).toFixed(2);
            var drawersValue = drawersProp ? drawersProp.value : '';
            properties['Storage Drawers'] = drawersValue + ' (+' + drawersFormatted + ')';
        }

        // If height addon needed, fetch its price
        if (heightAddonHandle) {
            promises.push(
                fetch('/products/' + heightAddonHandle + '.js')
                    .then(function (res) { return res.ok ? res.json() : null; })
                    .then(function (product) {
                        if (product) {
                            var addonVariant = product.variants[0];
                            var priceFormatted = '\u00a3' + (addonVariant.price / 100).toFixed(2);
                            var currentSize = properties['Headboard Size'] || sizeNumber + '"';
                            properties['Headboard Size'] = currentSize + ' (+' + priceFormatted + ')';
                            return addonVariant;
                        }
                        return null;
                    })
            );
        }

        Promise.all(promises).then(function (results) {
            // Main product
            items.push({ id: parseInt(variantId), quantity: quantity, properties: properties });

            // Mattress addon line item
            if (hasMattress) {
                items.push({
                    id: parseInt(mattressEl.value),
                    quantity: quantity,
                    properties: { 'Addon For': 'Frame Bed' }
                });
            }

            // Height addon line item
            if (heightAddonHandle && results[0]) {
                items.push({
                    id: results[0].id,
                    quantity: quantity,
                    properties: { 'Addon For': 'Frame Bed' }
                });
            }

            // Gas lift storage addon line item
            if (hasGasLift && gasLiftEl.value && gasLiftEl.value !== '' && gasLiftEl.value !== '0') {
                items.push({
                    id: parseInt(gasLiftEl.value),
                    quantity: quantity,
                    properties: { 'Addon For': 'Frame Bed' }
                });
            }

            // Storage drawers addon line item
            if (hasDrawers && drawersEl.value && drawersEl.value !== '' && drawersEl.value !== '0') {
                items.push({
                    id: parseInt(drawersEl.value),
                    quantity: quantity,
                    properties: { 'Addon For': 'Divan Bed' }
                });
            }

            // Submit all items
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items })
            });
        })
            .then(function (res) {
                if (!res.ok) throw new Error('Failed to add to cart');
                window.location.href = '/cart';
            })
            .catch(function () {
                alert('Error adding to cart. Please try again.');
                if (btn) { btn.innerHTML = originalText; btn.disabled = false; }
            });
    }
})();
